import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LinkyModule } from '@teammood/shared/util/linky';
import { TmSlideToggleComponent } from '@teammood/shared/ui/slide-toggle';
import { TmTimeZonePickerComponent } from '@teammood/shared/ui/timezone-picker';
import { AppErrorsComponent } from './app-errors';
import { AdminTeamMemberSettings, AdminTeamSettings } from "./team";
import { BouncesComponent } from './bounces/bounces.component';
import { CreatePasswordComponent } from './create-password/create-password.component';
import { EmailProviderRoutingComponent } from "./email-provider-routing/email-provider-routing.component";
import { ListOrganizationsComponent } from "./list-organizations/list-organizations.component";
import { EmailTemplatesComponent } from './email-templates/email-templates.component';
import { ModerationComponent } from './moderation/moderation.component';
import { SetYearlySubscriptionComponent } from './set-yearly-subscription/set-yearly-subscription.component';
import { AdminSearchComponent } from './search/admin-search.component';
import { AdminTeamSetupComponent } from './team/admin-team-setup.component';
import { TmPipesModule } from "../shared/util/pipes";
import { RemoveNonAlphanumericModule } from '../shared/util/remove-non-alphanumeric';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AdminMainComponent } from './admin-main/admin-main.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import 'quill-mention/autoregister';
import "quill";
import { TmRichTextAreaComponent } from "../shared/ui/rich-text-area/rich-text-area.component";
import { TmSharedUIModule } from "@teammood/shared/ui";
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatOption, MatSelect } from "@angular/material/select";
import { LoadingBarModule } from "@ngx-loading-bar/core";
import { TmTeamSelectComponent } from "@teammood/team";
import { TranslateModule } from "@ngx-translate/core";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { RouterModule, RouterOutlet } from "@angular/router";
import { OrganizationSettingsComponent } from "../organization/organization-settings.component";
import { OrganizationComponent } from "../organization/organization.component";
import { OrganizationCreateTeamComponent } from "../organization/organization-create-team.component";
import { authGuard } from "@teammood/shared/util/core";

@NgModule({ declarations: [
        AdminMainComponent,
        AdminSearchComponent,
        AdminTeamSetupComponent,
        AdminTeamSettings,
        AdminTeamMemberSettings,
        AppErrorsComponent,
        ListOrganizationsComponent,
        CreatePasswordComponent,
        BouncesComponent,
        ModerationComponent,
        EmailTemplatesComponent,
        EmailProviderRoutingComponent,
        SetYearlySubscriptionComponent,
    ], imports: [CommonModule,
        TmPipesModule,
        RemoveNonAlphanumericModule,
        FormsModule,
        LinkyModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        TmSlideToggleComponent,
        TmTimeZonePickerComponent,
        MatTooltipModule,
        MatMenuModule,
        MatToolbarModule,
        MatSidenavModule,
        MatListModule,
        TmRichTextAreaComponent,
        TmSharedUIModule,
        MatSelect,
        MatOption,
        LoadingBarModule,
        TmTeamSelectComponent,
        TranslateModule,
        MatSlideToggle,
        RouterOutlet,
        RouterModule.forRoot([
            {
                path: 'admin',
                component: AdminMainComponent,
                canActivate: [authGuard()],
                children: [
                    { path: 'search', component: AdminSearchComponent },
                    { path: 'bounces', component: BouncesComponent },
                    { path: 'app_errors', component: AppErrorsComponent },
                    { path: 'moderation', component: ModerationComponent },
                    { path: 'organizations', component: ListOrganizationsComponent },
                    { path: 'email_templates', component: EmailTemplatesComponent },
                    { path: 'email-provider-routing', component: EmailProviderRoutingComponent },
                    { path: 'create_password', component: CreatePasswordComponent },
                    { path: 'team/:teamId', component: AdminTeamSetupComponent },
                    { path: 'set_yearly_subscription/:teamId', component: SetYearlySubscriptionComponent },
                    { path: 'organization/:id/settings', component: OrganizationSettingsComponent },
                    { path: 'organization/:id/team/new', component: OrganizationCreateTeamComponent },
                    { path: 'organization/:id', component: OrganizationComponent },
                ]
            },
        ])], providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())] })
export class TmAdminModule{
}